import Vue from 'vue';

export default {
  install: () => {
    // input聚焦
    Vue.directive('focus', el => {
      let inputItem = el;

      for (const childItem of el.childNodes || []) {
        if (childItem.nodeName === 'INPUT') {
          inputItem = childItem;
          break;
        }
      }

      inputItem.focus && inputItem.focus();
    });
  }
};
